export enum HistogramTypeEnum {
    height = 0,
    dwell = 1,
    instantDwell = 2,
    unattendedTime = 3,
}
